/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';

/**
 * A command used to create a new security scheme in a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class NewSecuritySchemeCommand extends AbstractCommand {
    public _scheme : any;

    public _schemeName : string;

    public _schemeExisted : boolean;

    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super();
            if(this._scheme===undefined) this._scheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeExisted===undefined) this._schemeExisted = false;
            if(this._scheme===undefined) this._scheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeExisted===undefined) this._schemeExisted = false;
            (() => {
                this._scheme = Library.writeNode(scheme);
                this._schemeName = scheme.getSchemeName();
            })();
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
            if(this._scheme===undefined) this._scheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeExisted===undefined) this._schemeExisted = false;
            if(this._scheme===undefined) this._scheme = null;
            if(this._schemeName===undefined) this._schemeName = null;
            if(this._schemeExisted===undefined) this._schemeExisted = false;
        } else throw new Error('invalid overload');
    }
}
NewSecuritySchemeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewSecuritySchemeCommand";
NewSecuritySchemeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

